import { render, staticRenderFns } from "./MyInspectorsLoader.vue?vue&type=template&id=37acef32&"
import script from "./MyInspectorsLoader.vue?vue&type=script&lang=js&"
export * from "./MyInspectorsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports